import { useCallback, useState } from 'react';
import { ICalendarDate } from '../Calendar';
import { ICalendarViewState } from '../View/CalendarView';
export const useSingleCalendar = ({
  day,
  ...viewState
}) => {
  const [currentViewState, setCurrentViewState] = useState(viewState);
  const handleIncrementMonthIndex = useCallback(newViewState => {
    setCurrentViewState(newViewState);
  }, []);
  const handleDecrementMonthIndex = useCallback(newViewState => {
    setCurrentViewState(newViewState);
  }, []);
  const handleChangeViewYear = useCallback(year => {
    setCurrentViewState(prevState => ({
      ...prevState,
      year
    }));
  }, []);
  return {
    handleIncrementMonthIndex,
    handleDecrementMonthIndex,
    handleChangeViewYear,
    setCurrentViewState,
    currentViewState
  };
};